var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDelete(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6980_150157)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.9974 15.8333C5.9974 16.75 6.7474 17.5 7.66406 17.5H14.3307C15.2474 17.5 15.9974 16.75 15.9974 15.8333V7.5C15.9974 6.58333 15.2474 5.83333 14.3307 5.83333H7.66406C6.7474 5.83333 5.9974 6.58333 5.9974 7.5V15.8333ZM15.9974 3.33333H13.9141L13.3224 2.74167C13.1724 2.59167 12.9557 2.5 12.7391 2.5H9.25573C9.03906 2.5 8.8224 2.59167 8.6724 2.74167L8.08073 3.33333H5.9974C5.53906 3.33333 5.16406 3.70833 5.16406 4.16667C5.16406 4.625 5.53906 5 5.9974 5H15.9974C16.4557 5 16.8307 4.625 16.8307 4.16667C16.8307 3.70833 16.4557 3.33333 15.9974 3.33333Z",
    fill: "url(#paint0_linear_6980_150157)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6980_150157",
    x1: 16.8296,
    y1: 9.92922,
    x2: 4.55828,
    y2: 9.92922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005887"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6980_150157"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.998047)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDelete);
export default __webpack_public_path__ + "static/media/ic_delete.12219157911a79336339854ef9b048c9.svg";
export { ForwardRef as ReactComponent };